import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';

const PanelTitle = styled.div`
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 10px;
`;

const PanelSubTitle = styled.div`
  font-size: 18px;
`;

const Title = ({ title, subTitle }) => (
  <div style={{ flex: '1' }}>
    <PanelTitle>
      {title}
    </PanelTitle>
    <PanelSubTitle>
      {subTitle}
    </PanelSubTitle>
  </div>
);

export default Title;
